import { render, staticRenderFns } from "./BoxToSavingsInsight.vue?vue&type=template&id=57b14ad6&scoped=true"
import script from "./BoxToSavingsInsight.vue?vue&type=script&lang=js"
export * from "./BoxToSavingsInsight.vue?vue&type=script&lang=js"
import style0 from "./BoxToSavingsInsight.vue?vue&type=style&index=0&id=57b14ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b14ad6",
  null
  
)

export default component.exports